const CDN_ENABLED = true;
const CDN_NEXT_URL = 'https://d1u6k6nu5jeiha.cloudfront.net/staticmyapp/albprod/';

module.exports = { CDN_ENABLED, CDN_NEXT_URL };

